import request, { ResultHandler } from '@/core/utils/request'
const ProxyBaseUrl = '/business/order/proxy'

export const getOrderByCubeNo = async cubeNo => {
  const result = await request({
    url: `${ProxyBaseUrl}/${cubeNo}`,
    method: 'GET'
  })
  return ResultHandler(result, 'Failed to get business cube order!') ?? null
}

export async function reportProxyOrderShipment(shipmentId, reports) {
  const result = await request({
    url: `/business/proxy/shipments/${shipmentId}`,
    method: 'POST',
    data: reports
  })
  return ResultHandler(result, 'Faeild to report business shipment!') ?? null
}

export async function getProxyShippingReports(shipmentId) {
  const result = await request({
    url: `/business/proxy/shipments/${shipmentId}`,
    method: 'GET'
  })
  return ResultHandler(result, 'Faeild to get business shipment report!') ?? null
}

export async function getProxyShippingDailyReport(date) {
  const result = await request({
    url: `/business/proxy/shipments/report/${date}`,
    method: 'GET'
  })
  return ResultHandler(result, 'Faeild to get business shipment report!') ?? null
}
